// extracted by mini-css-extract-plugin
export var cardLayout = "_7a-1";
export var paginationContainer = "_7a-0";